import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';
import iconsIndex from './iconsIndex';

interface IIcons{
  name: keyof typeof iconsIndex,
  className?: string,
  onClick?: MouseEventHandler<SVGSVGElement>
}

const Icons = ({ name, className = 'icon', onClick }: IIcons) => {
  const Icon = iconsIndex[name];
  const classes = {
    [className]: true,
    icon: true,
  };

  return (
    <Icon onClick={onClick} className={classNames(classes)} />
  );
};

export default Icons;